import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./PaymentHistoryFilter.scss";
import { useFormik } from "formik";
import * as Yup from "yup";

import PaymentFilterDates from "./PaymentFilterDates";
import { RootState } from "../../../redux/store";
import { commonAction } from "../../../redux/features/commonSlice";
import CloseIcon from "../../../components/icons/CloseIcon";
import Loading from "../../loading/Loading";

interface PaymentHistoryFilterProps {
  onApply: (filters: any) => void;
  onClear: () => void;
  currentFilters: {
    start_date: string;
    end_date: string;
  };
}

const PaymentHistoryFilter: React.FC<PaymentHistoryFilterProps> = ({
  onApply,
  onClear,
  currentFilters,
}) => {
  const dispatch = useDispatch();

  let filterBox = useSelector(
    (state: RootState) => state?.common?.homePageFilter,
  );

  const filterRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  const onCloseFilter = () => {
    dispatch(commonAction.setHomePageFilter());
  };

  const onSubmitHandler = (values: any) => {
    onApply({
      start_date: values.start_date,
      end_date: values.end_date,
    });
    onCloseFilter();
  };

  const initialValues: any = {
    start_date: currentFilters?.start_date || "",
    end_date: currentFilters?.end_date || "",
    selectedAgentIds: [],
    selectedPropertyId: "",
    post_status: "",
    post_type: "",
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      start_date: Yup.string().optional(),
      end_date: Yup.string().optional(),
    }),
    onSubmit: onSubmitHandler,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const onClickClear = () => {
    formik.resetForm();
    onClear();
    onCloseFilter();
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterBox &&
        filterRef.current &&
        !filterRef.current.contains(event.target as Node)
      ) {
        // dispatch(commonAction.setHomePageFilter());
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filterBox, dispatch]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div
        className={`payment-filter-container ${
          filterBox ? "" : "deactivate-filter"
        }`}
      >
        <div className="filter-background" onClick={onCloseFilter}></div>
        <div className="properties-filter-box" ref={filterRef}>
          <div className="filter-top-heading">
            <p className="filter-top-head">Filters</p>
            <div className="filter-close-icon" onClick={onCloseFilter}>
              <CloseIcon />
            </div>
          </div>
          <div className="filter-body-container">
            {isLoading ? (
              <div className="property-filter-is-loading-contain">
                <Loading />
              </div>
            ) : (
              <>
                <PaymentFilterDates formik={formik} lable="Transaction Date" />
              </>
            )}
          </div>

          <div className="payment-action-btn-filter">
            <button
              className="clear-filters-btn"
              type="button"
              onClick={onClickClear}
            >
              Clear Filters
            </button>
            <button className="apply-btn" type="submit">
              Apply
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default PaymentHistoryFilter;
